<template>
    <div 
        class="delete-profile-popup"
        v-if="value" 
        @click="close"
    >
        <div 
            v-loading="loading"
            class="delete-profile-popup__card" 
            @click.stop
        >
            <div
                v-if="getError.show"
                class="delete-profile-popup__message"
            >
                {{ getError.text }}
            </div>
            <p class="delete-profile-popup__title">Вы уверены, что хотите удалить свой профиль?</p>
            <div class="delete-profile-popup__text-wrapper">
                <p class="delete-profile-popup__subtitle">Обратите внимание, что данный аккаунт дает вам право участвовать в проектах АНО «Россия – страна возможностей».</p>
                <p class="delete-profile-popup__text">Нажимая <span class="delete-profile-popup__type_warning">«Да, удалить»</span> - вы стираете все ваши данные и <span class="delete-profile-popup__type_warning">не сможете восстановить доступ к проектам</span>.
                </p>
                <p class="delete-profile-popup__text">
                Для ознакомления с проектами, в которых вы принимаете участие, перейдите в раздел 
                    <span
                        class="delete-profile-popup__type_link"
                        @click="goToProjects"
                    >«Проекты»</span>.
                </p>
            </div>
            <div class="delete-profile-popup__button-wrapper">
                <Button
                    outline
                    class="delete-profile-popup__btn delete-profile-popup__btn_confirm"
                    @click="deleteProfileHandler"
                >
                    Да, удалить
                </Button>
                <Button
                    class="delete-profile-popup__btn"
                    @click="close"
                >
                    Отмена
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/UI/Button';
import { mapActions, mapGetters } from 'vuex';

const actions = [
    'deleteProfile',
];

const getters = [
    'getError',
];

export default {
    name: 'DeleteProfilePopup',
    components: {
        Button,
    },
    data: () => ({
        loading: false,
        showErrorMessage: false,
        errorText: 'Произошла ошибка. Попробуйте позже.',
    }),
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        ...mapActions(actions),
        close() {
            this.$emit('input', false);
        },
        deleteProfileHandler() {
            this.loading = true;
            this.deleteProfile();
        },
        goToProjects() {
            this.close();
            this.$router.push({ path: '/account/projects'});
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.delete-profile-popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;

    &__card {
        position: relative;
        padding: rem(40) rem(32);
        width: rem(602);
        background-color: #ffffff;
        opacity: 1;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: auto;

        @include on-mobile {
            padding: mrem(40) mrem(24);
            width: mrem(343);
        }
    }

    &__message {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: mrem(16);
        background: #fff;
        @include on-desktop {
            font-size: rem(16);
        }
    }

    &__title {
        margin: 0 0 mrem(18);
        font-size: mrem(20);
        line-height: mrem(28);
        font-weight: bold;
        text-align: center;
        color: #2A2626;

        @include on-desktop {
            margin-bottom: rem(20);
            font-size: rem(18);
            line-height: rem(22);
        }
    }

    &__subtitle {
        font-weight: bold;
        font-size: mrem(16);
        margin: 0 0 mrem(20) 0;
        line-height: mrem(20);
        @include on-desktop {
            font-size: rem(16);
            margin: 0 0 rem(20) 0;
            line-height: rem(20);
        }
    }

    &__text-wrapper {
        width: 100%;
        margin-bottom: mrem(24);
        @include on-desktop {
            width: rem(490);
            margin-bottom: rem(40);
        }
    }

    &__text {
        font-size: mrem(16);
        line-height: mrem(20);
        @include on-desktop {
            font-size: rem(16);
            line-height: rem(20);
        }
    }

    &__type {
        &_warning {
            color: #D1004A;
        }
        &_link {
            cursor: pointer;
            color: #4663AB;
            text-decoration: underline;
        }
    }

    &__button-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        @include on-desktop {
            flex-direction: row;
            justify-content: space-between;
        }

    }

    &__btn {
        width: 100%;

        &_confirm {
            margin-bottom: mrem(12);
            @include on-desktop {
                margin-bottom: 0;
            }
        }
        @include on-desktop {
            width: rem(257);
        }
    }
}
</style>

